import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import "./style.css"
const Wrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 18px;
  height: 18px;
  background-color: #000;
  border: 2px solid #fff;
  border-radius: 100%;
  user-select: none;
  transform: translate(-50%, -50%);
  cursor: ${(props) => (props.onClick ? 'pointer' : 'default')};
  &:hover {
    z-index: 1;
  }
`;


const Marker = ({ no ,postalCode,thic ,zoom}) => (
  // <Wrapper
  //   alt={text}
  //   onClick={onClick}
  // />




  <div class="po__wrapper"  style={{padding:0 ,margin:0}}>

        <div  
        class="po__title"
         style={{width:`${Math.max(Math.min(thic*zoom,75),15)}px` ,height : `${Math.max(Math.min(thic*zoom,75),15)}px`,padding:0 ,margin:0 }}
      >
      {zoom>7? no:"" }
      </div>

  <div class="po__content">
    <p class="po__message">Zip Code: {postalCode}</p>
    <p class="po__message">Visits: {no}</p>

  </div>
</div>


);

Marker.defaultProps = {
  onClick: null,
};

Marker.propTypes = {
  onClick: PropTypes.func,
  text: PropTypes.string.isRequired,
};

export default Marker;
